export default __webpack_public_path__ + "static/media/Debit.a38f37e0.svg";